var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6092 14.7131L0.272461 28.1026C0.27362 28.105 0.273619 28.1085 0.274778 28.1109C0.653676 29.5648 1.95143 30.6348 3.49252 30.6348C4.10895 30.6348 4.68715 30.4641 5.18307 30.1655L5.22247 30.1418L19.1084 21.9482L12.6092 14.7131Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.09 12.4336L25.0784 12.4253L19.0832 8.87175L12.3291 15.0179L19.1076 21.9473L25.0703 18.4293C26.1154 17.851 26.8257 16.7242 26.8257 15.4255C26.8257 14.1339 26.1259 13.013 25.09 12.4336Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.272733 2.69068C0.198576 2.97032 0.15918 3.26418 0.15918 3.56751V27.2279C0.15918 27.5312 0.198576 27.8251 0.273892 28.1035L13.0336 15.0564L0.272733 2.69068Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6998 15.3965L19.0843 8.8688L5.21454 0.645497C4.7105 0.336235 4.12188 0.158498 3.4927 0.158498C1.95161 0.158498 0.651541 1.23084 0.272642 2.68592C0.272642 2.6871 0.271484 2.68829 0.271484 2.68947L12.6998 15.3965Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/Playstore.352f3bb1c571ba7daa0a31678b19dba5.svg";
export { ForwardRef as ReactComponent };